module.exports = __webpack_public_path__ + "static/media/Preview.93362afb.svg";